import React from 'react'
import { Box } from 'theme-ui'

const Primary = () => {
  return <Box sx={{fontSize: [5], color: 'primary'}}>
    This is primary too
  </Box>
}

export default Primary
